import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense } from 'react'
import { Outlet } from 'react-router'
import { PlatformBreadcrumbs } from '../PlatformBreadcrumbs'
import { RedisMenu } from '../RedisMenu'

export function PlatformDagsterPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Dagster" />}>
        <RedisMenu />
      </PageHeader>
      <QueryErrorBoundary errorMessage="Failed to fetch Dagster applications">
        <Suspense fallback={<PlatformDagsterPageLoading />}>
          <Outlet />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function PlatformDagsterPageLoading() {
  return (
    <TablePageContainer>
      <div className="flex size-full items-center justify-center">
        <LoadingComponent text="Loading Dagster applications..." />
      </div>
    </TablePageContainer>
  )
}
